export default __webpack_public_path__ + "static/media/estoreMerchandise.51ec7566.png";